import Moment from 'moment';
import {extendMoment} from 'moment-range';
import 'moment/locale/de';

const moment = extendMoment(Moment);

export default moment;


// WEBPACK FOOTER //
// ./src/misc/moment.js